import { commitMutation,
  graphql } from 'react-relay';
import environment from '..';
import { basicMutationOnCompleted, onErrorMutation } from './common/common';

const mutation = graphql`
mutation RemoveByEmailInvitationMutation($email: String!) {
  removeByEmailInvitation(email: $email) {
    ok
    error
  }
}
`;

export default ({ email }, done) => {
  const variables = { email };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ removeByEmailInvitation }) => basicMutationOnCompleted(removeByEmailInvitation, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
